import React from 'react';
import Modal from 'react-bootstrap/Modal';
import DOMPurify from 'dompurify';
import { LoaderMedium } from '../components/loader';

function ModalWrapper(props) {

    return (
      <> 
        <Modal dialogClassName="modal-70w" show={props.isShow||false} onHide={(e) => props._toggleModal(e, false)} size="lg" className="mod-custom team-detail view-details" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="scroll-wrap">
                {props.loader 
                ?
                    <div className="text-center mt-5 mb-5">
                        <LoaderMedium size={45} />
                    </div>
                :
                    <div className="scroll-div">
                    {props?.detail_type === 'html'
                    
                        ?
                            <div
                                dangerouslySetInnerHTML={{ 
                                    __html: DOMPurify.sanitize(props.data, { ADD_TAGS: ["style"] }) 
                                }}
                            />
                        :
                            props.data
                    }
                    </div>
                }
                </div>
            </Modal.Body>
            <Modal.Footer className="team-detail">
                <button className="btn btn-secondary" onClick={(e) => props._toggleModal(e, false)}>Close</button>
            </Modal.Footer>
        </Modal>
      </>
    );
}
  
export default ModalWrapper;